import { NgModule } from '@angular/core';
import { PublishDialogService, UnpublishDialogService } from '@mode/dataset/contract';
import { PublishDatasetDialogService } from './publish-dataset-dialog/publish-dataset-dialog.service';
import { UnpublishDatasetDialogService } from './unpublish-dataset-dialog/unpublish-dataset-dialog.service';
import { PublishDatasetBannerComponent } from './publish-dataset-banner/publish-dataset-banner.component';

@NgModule({
  imports: [PublishDatasetBannerComponent],
  providers: [
    { provide: PublishDialogService, useClass: PublishDatasetDialogService },
    { provide: UnpublishDialogService, useClass: UnpublishDatasetDialogService },
  ],
})
export class PublishModule {}
